import * as React from "react";
import { useTranslation } from "react-i18next";
import ProfileGroups from "../../presentations/ProfileGroups";

const ProfileGroupsContainer = () => {

  const { t } = useTranslation();
  
  return (
    <div>
    <div className="mb-2 font-semibold text-gray-700">
    {t("profileSummary.label.groups")}
  </div>
    <div>
      <ProfileGroups></ProfileGroups>
    </div>
    </div>
  );
};

export default ProfileGroupsContainer;
